import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { Messages } from '../../codegen/Localize';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { GetPersonalSpaceAction, getPersonalSpace, getPersonalSpaceSucceded, isGetPersonalSpaceAction } from '../actions/PersonalSpaceActions';
import { callViaApiService } from '../../ts/restApi/personalSpace/PersonalSpace';
import { FeatureFlags } from '../../ts/FeatureFlags';

export function* rootPersonalSpaceSaga(): SagaIterator {
  yield takeEvery(getPersonalSpace, handleGetPersonalSpace);
}

export function* handleGetPersonalSpace(action: GetPersonalSpaceAction) {
  try {
    if (FeatureFlags.personalSpaceEnabled && isGetPersonalSpaceAction(action)) {
      const result =  yield call(callViaApiService);
      yield put(getPersonalSpaceSucceded(result.personalSpace));
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}